import React, { useEffect, useState, useContext, useRef } from "react";
import PropTypes from "prop-types";
import Tools from "./JNSTools";
import DashboardProjectLinks from "./DashboardProjectLinks_sfgrid";
import { CredsContext, HelpModeContext } from "./Contexts";

function DashboardProjectLinksContainer(props) {
  const [workspaceLinkTable, setWorkspaceLinkTable] = useState([]);
  const creds = useContext(CredsContext).creds;

  useEffect(() => {
    if (props.panelLocked) {
      const urlString = Tools.getInstanceUrl(creds);
      const authString = Tools.getXmlBodyAuthString(creds);
      const requestString =
        authString +
        '<Read type="Workspacelink" method="all" limit="1000"></Read></request>';
      Tools.fetchPost(requestString, urlString, "Workspacelink").then(
        (wlRecords) => {
          const linksTable = Tools.xmlToArray(wlRecords.xml);
          setWorkspaceLinkTable(linksTable);
        },
      );
    }
  }, []);

  return (
    <DashboardProjectLinks
      projectObject={props.projectObject}
      wlTable={workspaceLinkTable}
      waitHandler={props.waitHandler}
      panelLocked={props.panelLocked}
      removePanel={props.removePanel}
      panelId={props.panelId}
    />
  );
}

export default DashboardProjectLinksContainer;

DashboardProjectLinksContainer.propTypes = {
  waitHandler: PropTypes.func,
  projectObject: PropTypes.object,
  panelLocked: PropTypes.bool,
  removePanel: PropTypes.func,
  panelId: PropTypes.number,
};
